import React from 'react';
import { Field } from 'redux-form';
import { Form, Row, Col, Button } from 'antd';
import AntIcon from '../../shared/components/AntIcon';

import {
  formItemLayout,
  formItemLayoutWithoutLabel,
  renderInput, renderSelect,
} from '../../shared/utils/form_components';
import { required, url } from '../../shared/utils/form_validations';

const RaffleLinkFields = ({ fields, label, raffleOptions, filterOptions }) => {
  return (
    <div>
      {fields.map((path, index, fields) => {
        return (
          <Form.Item
            {...(index === 0 ? formItemLayout : formItemLayoutWithoutLabel)}
            key={path}
            label={index === 0 ? label : null}
          >
            <Row gutter={8}>
              <Col span={7}>
                <Field
                  inputOnly
                  showSearch
                  name={`${path}.raffleId`}
                  placeholder="Raffle"
                  options={raffleOptions}
                  filterOption={filterOptions}
                  component={renderSelect}
                  validate={required}
                />
              </Col>
              <Col span={13}>
                <Field
                  inputOnly
                  name={`${path}.link`}
                  placeholder="Link"
                  component={renderInput}
                  validate={[required, url]}
                />
              </Col>
              <Col className="is-right">
                {index > 0 &&
                  <AntIcon
                    type="arrow-up"
                    style={{ cursor: 'pointer' }}
                    onClick={() => fields.swap(index, index - 1)}
                  />
                }
                {index < fields.length - 1 &&
                  <AntIcon
                    type="arrow-down"
                    style={{ cursor: 'pointer' }}
                    onClick={() => fields.swap(index, index + 1)}
                  />
                }
                &nbsp;&nbsp;
                <AntIcon
                  type="minus-circle-o"
                  onClick={() => fields.remove(index)}
                  style={{ cursor: 'pointer', color: 'red' }}
                />
              </Col>
            </Row>
          </Form.Item>
        )})}

      <Form.Item
        {...(fields.length === 0 ? formItemLayout : formItemLayoutWithoutLabel)}
        label={fields.length === 0 ? label : null}
      >
        <Button type="dashed" onClick={() => fields.push({})} style={{ width: '60%' }}>
          <AntIcon type="plus" />Add Raffle Link
        </Button>
      </Form.Item>
    </div>
  );
}

export default RaffleLinkFields;
